const SegnalazioneFlowStateLabels : {[key: string]: string} = {
    IN_COMPILAZIONE : "In compilazione",
    PROTOCOLLATA : "Protocollata",
    DA_ASSEGNARE : "Da assegnare",
    ASSEGNATA : "Assegnata",
    IN_ELABORAZIONE : "In elaborazione",
    IN_ATTESA_DECISIONE_COMMISSIONE : "In attesa della decisione della commissione"
}

export default SegnalazioneFlowStateLabels